/* @flow */
import { GET_ACTIVITIES, WRITE_COMMENT, ADD_ACTIVITY_TO_FAVORITE, REMOVE_ACTIVITY_FROM_FAVORITE } from '../configs/constants'

export function getActivities() {
  return { type: GET_ACTIVITIES }
}

// export function setViewActivity(activity) {
//   return { type: SET_VIEW_ACTIVITY, activity }
// }

export function writeComment(comment) {
  return { type: WRITE_COMMENT, comment }
}

export function addToFavorite(payload) {
  return { type: ADD_ACTIVITY_TO_FAVORITE, payload }
}

export function removeFavorite(payload) {
  return { type: REMOVE_ACTIVITY_FROM_FAVORITE, payload }
}


// WEBPACK FOOTER //
// ./src/actions/activity.js